{
  "lumber_yard": "Leñera",
  "stone_pit": "Pedrera",
  "clay_pool": "Charca de arcilla",
  "ore_vein": "Veta de mineral",
  "tree_farm": "Vivero",
  "excavation": "Excavación",
  "clay_pit": "Foso de arcilla",
  "timber_yard": "Almacén de madera",
  "forest_cave": "Cueva del bosque",
  "mine": "Mina",
  "loom": "Telar",
  "glassworks": "Vidriería",
  "press": "Prensa",
  "altar": "Altar",
  "theater": "Teatro",
  "well": "Pozo",
  "baths": "Termas",
  "tavern": "Taberna",
  "east_trading_post": "Puesto comercial este",
  "west_trading_post": "Puesto comercial oeste",
  "marketplace": "Mercado",
  "guard_tower": "Torre de guardia",
  "barracks": "Cuartel",
  "stockade": "Empalizada",
  "scriptorium": "Scriptorium",
  "apothecary": "Botica",
  "workshop": "Taller",
  "sawmill": "Aserradero",
  "quarry": "Cantera",
  "brickyard": "Ladrillería",
  "foundry": "Fundición",
  "courthouse": "Tribunal",
  "temple": "Templo",
  "statue": "Estatua",
  "aqueduct": "Acueducto",
  "caravansery": "Caravasar",
  "forum": "Foro",
  "vineyard": "Viñedo",
  "bazaar": "Bazar",
  "stables": "Establos",
  "archery_range": "Campo de tiro",
  "walls": "Murallas",
  "training_ground": "Campo de entrenamiento",
  "dispensary": "Dispensario",
  "laboratory": "Laboratorio",
  "library": "Biblioteca",
  "school": "Escuela",
  "gardens": "Jardines",
  "senate": "Senado",
  "town_hall": "Ayuntamiento",
  "pantheon": "Panteón",
  "palace": "Palacio",
  "haven": "Puerto",
  "lighthouse": "Faro",
  "chamber_of_commerce": "Cámara de comercio",
  "arena": "Arena",
  "ludus": "Ludus",
  "arsenal": "Arsenal",
  "siege_workshop": "Taller de asedio",
  "fortifications": "Fortificaciones",
  "circus": "Circo",
  "castrum": "Castrum",
  "university": "Universidad",
  "study": "Gabinete",
  "lodge": "Logia",
  "academy": "Academia",
  "observatory": "Observatorio",
  "workers_guild": "Gremio de trabajadores",
  "craftsmens_guild": "Gremio de artesanos",
  "magistrates_guild": "Gremio de magistrados",
  "traders_guild": "Gremio de comerciantes",
  "spies_guild": "Gremio de espías",
  "philosophers_guild": "Gremio de filósofos",
  "shipowners_guild": "Gremio de armadores",
  "scientists_guild": "Gremio de científicos",
  "builders_guild": "Gremio de constructores",
  "decorators_guild": "Gremio de decoradores"
}
